import { AuthActions } from "./actions";
import { AUTH_CHANGE_PERSPECTIVE } from "./actions/AuthChangePerspective";
import { AUTH_COMPLETE_EMAIL_VERIFICATION_END } from "./actions/AuthCompleteEmailVerification";
import { AUTH_LOGIN_FAILURE, AUTH_LOGIN_REQUEST, AUTH_LOGIN_SUCCESS } from "./actions/AuthLogin";
import { AUTH_LOGOUT_REQUEST } from "./actions/AuthLogout";
import { AUTH_SET_PROFILE_REQUEST } from "./actions/AuthSetProfile";
import { AUTH_SET_TOKEN_REQUEST } from "./actions/AuthSetToken";
import { authChangePerspective } from "./reducer/AuthChangePerspective";
import { completeEmailVerification } from "./reducer/AuthCompleteEmailVerification";
import { authLoginFailure, authLoginRequest, authLoginSuccess } from "./reducer/AuthLogin";
import { authLogout } from "./reducer/AuthLogout";
import { authSetProfile } from "./reducer/AuthSetProfile";
import { authSetToken } from "./reducer/AuthSetToken";
import { AuthState } from "./state";
import { getAWSID, getCodeVerifier, getStoredAuthState, getStoredRedirectUrl, getStoredStateParameter } from "./util";

const initialState: AuthState = {
    credentials: undefined,
    isLoggingIn: false,
    profile: undefined
};

const logoutFunction = authLogout(initialState);

export function authReducer(
    state = {
        ...initialState,
        ...getStoredAuthState(),
        ...{
            awsId: getAWSID(),
            codeVerifier: getCodeVerifier(),
            redirectUrl: getStoredRedirectUrl(),
            state: getStoredStateParameter(),
        }
    },
    action: AuthActions
): AuthState {
    switch (action.type) {
        case AUTH_CHANGE_PERSPECTIVE:
            return authChangePerspective(state, action);
        case AUTH_LOGIN_REQUEST:
            return authLoginRequest(state, action);
        case AUTH_SET_TOKEN_REQUEST:
            return authSetToken(state, action);
        case AUTH_SET_PROFILE_REQUEST:
            return authSetProfile(state, action);
        case AUTH_LOGIN_SUCCESS:
            return authLoginSuccess(state, action);
        case AUTH_LOGIN_FAILURE:
            return authLoginFailure(state, action);
        case AUTH_LOGOUT_REQUEST:
            return logoutFunction(state, action);
        case AUTH_COMPLETE_EMAIL_VERIFICATION_END:
            return completeEmailVerification(state, action);
        default:
            return state;
    }
}
